import { AuthConfig } from 'angular-oauth2-oidc';

export const GoogleAuthConfig: AuthConfig = {


  // Url of the Identity Provider
  issuer: 'https://tspherecomputing.b2clogin.com/4b509e6e-e5f7-4b6b-b3ad-ea1dcd7847f2/v2.0/',

  // URL of the SPA to redirect the user to after login
  //redirectUri:"http://localhost:4200/retail-fe/index.html",
  redirectUri: window.location.origin + '/index.html',

  // The SPA's id. The SPA is registered with this id at the auth-server
  clientId: '35942418-86ed-4ea4-90d6-1b6133d652ee',

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'openid 35942418-86ed-4ea4-90d6-1b6133d652ee',

  strictDiscoveryDocumentValidation: false,
  showDebugInformation: true,
  timeoutFactor: 0.01,
  checkOrigin: false,
  sessionChecksEnabled: true,
  clearHashAfterLogin: true,

}